module.exports = __webpack_public_path__ + "img/flag_g.b022d6cd.png";